import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import SEO from "@components/seo";
import MainContent from "@components/content";
import * as Types from '../../types';
import AddPopupProduct from "@components/addProductPopup";
import useUserData from "@hooks/useUserData";
import { toast } from "sonner";
import CountContainer from "@components/countContainer";

export default function Product() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { favoriteData, refreshFavoriteData, cartData } = useUserData();
  const [product, setProduct] = useState<Types.Product[]>([]);
  const [addProductPopup, setAddProductPopup] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const startX = useRef(0);
  
  const handleTouchStart = (e: React.TouchEvent) => {
    startX.current = e.touches[0].clientX;
  };
  
  const handleTouchEnd = (e: React.TouchEvent) => {
    const endX = e.changedTouches[0].clientX;
    const deltaX = endX - startX.current;
  
    if (Math.abs(deltaX) > 50) {
      if (deltaX > 0) {
        // свайп вправо
        setActiveIndex((prev) => (prev === 0 ? product[0].images.length - 1 : prev - 1));
      } else {
        // свайп влево
        setActiveIndex((prev) => (prev + 1) % product[0].images.length);
      }
    }
  };
  
  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_URL}/product/${id}`, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      setProduct(response.data);
    }).catch(error => {
      const id = Math.floor(Math.random() * 100000);
      toast.error(`Ошибка при загрузке, код ошибки: ${id}`);
      console.log(error);

      axios.post(`${import.meta.env.VITE_API_URL}/log`, { id, error }, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
    });
  }, [id]);

  const back = () => {
    navigate(-1);
  }
      
  const manageFavorite = (type: number, id: number) => {
      axios.post(`${import.meta.env.VITE_API_URL}/user/favorites/${type === 0 ? "add" : "remove"}`, { productId: id },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((_) => {
          toast.success(type === 0 ? "Добавили продукт в избранное" : "Удалили продукт из избранного");
          refreshFavoriteData();
      })
      .catch((error) => {
          console.log(error);
      });
  };

  return (
    <MainContent header={null}>      
      <AddPopupProduct product={product[0]} showPopup={addProductPopup} setShowPopup={setAddProductPopup} />
      {product.map((info: Types.Product) => (
      <>
        <SEO 
          title={info.name}
          description={info.desc}
          ogImage={info.images[0]}
          ogUrl={`https://рыбныимир.рф/`}
        />

        <div className={css.mainInfo}>
          <a onClick={back} className={css.exit}><i className="fi fi-rr-angle-small-left"></i></a>
          {info.images.length > 0 && (
            <div
              className={css.imageSwipeBlock}
              style={{ backgroundImage: `url(${info.images[activeIndex]})` }}
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              <div className={css.dots}>
                {info.images.map((_, index: number) => (
                  <div key={index} className={`${css.dot} ${index === activeIndex ? css.act : ''}`} onClick={() => setActiveIndex(index)} />
                ))}
              </div>
            </div>
          )}
          {info.images.length < 1 && (
            <div
              className={css.imageSwipeBlock}
              style={{ backgroundImage: `url(/assets/images/noImage.jpg)` }}
            >
            </div>
          )}

          <div className={css.textBlock}>
            <h1>{info.name}</h1>
            <b>{info.price} ₽ / {info.unit}</b>
            <p dangerouslySetInnerHTML={{__html: info.desc ? info.desc : '' }}></p>
          </div>

          <div className={css.flexButtons}>
            {!cartData.find(cart => cart.product.id === info.id) ? (
              <button className={css.addToCart} onClick={(e) => { e.stopPropagation(); setAddProductPopup(true) }}>В корзину <i className="fi fi-rr-shopping-cart" /></button>
            ) : (
                <CountContainer id={info.id} unit={info.unit} style={{ marginTop: 10 }} />
              )
            }
            
            <div className={`${css.addToFavorite} ${favoriteData.find(favorite => favorite.productId == info.id) ? css.activeFavorite : ''}`} onClick={() => manageFavorite(favoriteData.find(favorite => favorite.productId == info.id) ? 1 : 0, info.id)}>
              <a>{favoriteData.find(favorite => favorite.productId == info.id) ? 'Избранное' : 'В избранные'}</a> <i className={favoriteData.find(favorite => favorite.productId == info.id) ? `${css.favoriteIcon} fi fi-sr-heart` : "fi fi-rr-heart"} />
            </div>
          </div>
          <div className={css.backButton} onClick={back}>
            <i className="fi fi-rr-angle-small-left" /> <a>Вернуться назад</a>
          </div>
        </div>
      </>
      ))}
    </MainContent>
  )
}
